import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { server } from "../../config/server.js";
import ViewCount from "../../components/ViewCount.js";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import logistikMain from "../../assets/logistikMain.png";
import ReactPaginate from "react-paginate";
export default function Berita() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [newsList, setNewsList] = useState([]);
  const [newsInPage, setNewsInPage] = useState([]);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  useEffect(() => {
    getData();
    getNews();
    window.scrollTo(0, 0);
  }, []);

  const getData = async () => {
    try {
      const response = await fetch(`${server}/api/v1/content/list/32`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status) {
        setData(result.data[0] || {});
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (err) {
      console.log("Error fetching data:", err);
    }
  };

  const getNews = () => {
    fetch(`${server}/api/v1/news/list?limit=5`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {

          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            element.formatted_url =  element.news_title.replace(/ /g, "-")
          }
          console.log(res.data);
          
          setNewsList(res.data || []);
          setNewsInPage(res.data.slice(itemOffset, itemOffset + itemsPerPage));
          // array.slice(offset, offset + itemsPerPage)
        } else {
          throw new Error("Failed to fetch news");
        }
      })
      .catch((err) => {
        console.log("Error fetching news:", err);
      });
  };

  const handleNewsClick = (news) => {
    navigate(`/media/berita/${news.news_id}/${news.news_title}`, {
      state: { news: news },
    });
  };

  const backgroundImage = data ? data.content_header_link : null;

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = newsList.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(newsList.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    window.scrollTo(0, 0);
    const newOffset = (event.selected * itemsPerPage) % newsList.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
    setNewsInPage(newsList.slice(newOffset, newOffset + itemsPerPage));
  };
  return (
    <>
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={newsList.map((news) => ({
          src: news.images[0]?.public_link || "",
        }))}
        plugins={[Thumbnails]}
        index={selectedImage}
      />
      {/* {JSON.stringify(data.content_header_link)} */}
      <img
        class="w100"
        style={{ borderRadius: 20 }}
        src={backgroundImage}
      ></img>
      <div className="pageTitle">{data.content_title || "Loading..."}</div>

      <div className="articleContainer pageText">
        <div className="list image">
          <div className="w100 fotoCardContainer">
            {newsInPage.map((news, index) => (
              <div
                key={index}
                className="newsCard mx-4 mb-5 pointer"
                // onClick={() => handleNewsClick(news)}
              >
                <a
                  href={`${server}/media/berita/${news.news_id}/${news.formatted_url}`}
                >
                  <div
                    className="newsThumbnail"
                    style={{
                      backgroundImage: `url("${
                        news.images[0]?.public_link || ""
                      }")`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      cursor: "pointer",
                    }}
                  ></div>
                  <div className="newsName greenText pageText greenText">
                    {news.news_title}
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      color: "#808080",
                      fontWeight: 400,
                    }}
                    className="pb-2"
                  >
                    {moment(news.news_entry_date)
                      .locale("id")
                      .format("DD MMM YYYY")}
                  </div>
                  <div
                    className="newsIntro"
                    dangerouslySetInnerHTML={{ __html: news.content }}
                  ></div>{" "}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="paginationContainer w100">
        {/* Pagination component or logic goes here */}
      </div>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        className="pagination-class px-3"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
        activeClassName="page-active"
      />
      <ViewCount count={data.views || 0} />
    </>
  );
}
